module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAABAUlEQVQ4jZ3UMUoEMRSA4T9zAc9gbe2CoiK6iK8Rwdu8A+QelguCZVhUFl1FxdprWNo+yRqGGZzkgamm+PiTzCQTzIzaCCleAtcmulVFA9c1wAlwC3w5od5NxkKKc+ABeDTR7UZo5P5ss4A7YG2iR05o5EaxkOIZsAReTXS/EZp03QCcFvDihKquG4B74NlED5xQ1XUhxasCliZ62Ai5Lq/sJj+Y6HktVIbrcuyizPzkxFy3+ZohxWNgBbyZ6F4VO64/GiHF/B7yrB8mOmsEq64/Gia6BvJB3A0pvtdiLTd1A/69wsm/xgB+AjMT/XaCGzd50ctW8gHdARbOln8dLH4A7eCfxAu7a7EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/prev_type.png
// module id = tUKG
// module chunks = 10